import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Select } from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { getOTACodes } from '../../../../../services/common';


interface propsTypes {
    cancellationDetails: void | any,
    toggleToViewMode: void | any,
    setDetails: void | any,
    currentForm: void | any
}
const Option = Select.Option
const PenaltyEdit = (props: propsTypes) => {
    const [currentOptions, setCurrentOptions] = useState<{ id: number, codeType: string, codeValue: string, codeName: string, subCat: any }[]>([])
    const getCurrentOptions = async () => {
        const res = await getOTACodes('CUR', '')
        if (res.result.success) {
            setCurrentOptions(res.otacodes)
        } else {
            setCurrentOptions([])
        }
    }
    const [chargeName, setChargeName] = useState<any>(`Charge (${props?.cancellationDetails?.chargetype})`)
    useEffect(() => {
        getCurrentOptions()
    }, [])


    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props.cancellationDetails?.policycode}>
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                        <>
                            <Col span={6} className="col-margin">
                                <Form.Item name="chargetype" label="Charge Type">
                                    <Select
                                        allowClear
                                        onChange={value => setChargeName(`Charge (${value})`)}
                                        showSearch
                                    >
                                        <Option value="Amount">Amount</Option>
                                        <Option value="Percent">Percent</Option>
                                        <Option value="Nights">Nights</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6} className="col-margin">
                                {
                                    <>
                                        {
                                            chargeName === 'Charge (Amount)' &&
                                            <Form.Item name="chargeamount" label={chargeName} rules={[
                                                { required: true, message: 'This field is required' },
                                                { pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number.' }
                                            ]}>
                                                <Input />
                                            </Form.Item>
                                        }
                                        {
                                            chargeName === 'Charge (Percent)' &&
                                            <Form.Item name="chargepercent" label={chargeName} rules={[
                                                { required: true, message: 'This field is required' },
                                                { pattern: /^\d*(\.\d*)?$/, message: "This field should be a number." }
                                            ]}>
                                                <Input />
                                            </Form.Item>

                                        }
                                        {
                                            chargeName === 'Charge (Nights)' &&
                                            <Form.Item name="chargenights" label={chargeName} rules={[
                                                { required: true, message: 'This field is required' },
                                                { pattern: /^\d*?$/, message: "This field should be a number." }
                                            ]}>
                                                <Input />
                                            </Form.Item>
                                        }
                                    </>
                                }

                            </Col>
                            <>
                                {
                                    chargeName === 'Charge (Amount)' && <Col span={6} className="col-margin">
                                        <Form.Item name="currency" label="Currency" rules={[
                                            { required: true, message: 'This field is required' },
                                        ]}>
                                            <Select allowClear showSearch
                                                placeholder="Select a currency"
                                                optionFilterProp="children"
                                                // @ts-expect-error
                                                filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {currentOptions.map((item: any) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                }
                            </>

                            <Col span={24} className="col-margin">
                                <Form.Item
                                    name="description"
                                    label="Description"
                                    rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                                >
                                    <TextArea maxLength={300} rows={3} style={{ resize: 'none' }}/>
                                </Form.Item>
                            </Col>
                            <Col span={6} className="col-margin">
                                <Form.Item name="taxinclusive" label="Tax Inclusive">
                                    <Select allowClear showSearch>
                                        <Option value="true">Yes</Option>
                                        <Option value="false">No</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name="feeinclusive" label="Fee Inclusive">
                                    <Select allowClear showSearch>
                                        <Option value="true">Yes</Option>
                                        <Option value="false">No</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </>
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default PenaltyEdit;

